// extracted by mini-css-extract-plugin
module.exports = {"termsAndCondsLinks":"style__termsAndCondsLinks__bJotY"};